export const messages = {
  testimonials: "Testimonials",
};
